import React, { useState } from "react";
import Header from "../components/Header";
import Header2 from "../components/Header2";
import Footer from "../components/Footer";

import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";
import "../assets/css/menu.css";
import "../assets/css/vendors.css";
import "../assets/css/icon_fonts/css/all_icons_min.css";
import "../assets/css/custom.css";

const doctorsData = [
  {
    name: "Dr. Priya Sharma",
    qualification: "MBBS, MS - General Surgery, MCh - Surgical Oncology",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "15 Years Experience",
    location: "2nd Floor, MS Tower, Banjara Hills, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Breast Lump Specialist"
  },
  {
    name: "Dr. Anjali Mehta",
    qualification: "MBBS, MD - Radiology, Fellowship - Breast Imaging",
    fee: " FREE Consultation",
    rating: "4.9/5",
    experience: "12 Years Experience",
    location: "Apurupa Urban, No 201, 2nd Floor, Image Gardens Rd, near Chirec School, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Breast Ultrasound Expert"
  },
  {
    name: "Dr. Rohan Verma",
    qualification: "MBBS, MS - General Surgery, DNB - Surgical Oncology",
    fee: " FREE Consultation",
    rating: "4.7/5",
    experience: "14 Years Experience",
    location: "Annapurna Kalyana Mandapam Srinagar Nagar, Dilsukhnagar, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Breast Biopsy Specialist"
  },
  {
    name: "Dr. Sneha Reddy",
    qualification: "MBBS, MD - Pathology, Fellowship - Cytopathology",
    fee: " FREE Consultation",
    rating: "4.6/5",
    experience: "11 Years Experience",
    location: "123 Green Avenue, Banjara Hills, Hyderabad",
    phone: "080-6541-7710",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Breast Pathology Expert"
  },
  {
    name: "Dr. Kavita Patel",
    qualification: "MBBS, MS - General Surgery, MCh - Surgical Oncology",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "16 Years Experience",
    location: "45 Tower Road, Jubilee Hills, Hyderabad",
    phone: "080-6541-7720",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Advanced Breast Surgery"
  },
  {
    name: "Dr. Arjun Kumar",
    qualification: "MBBS, MD - Radiology, DNB - Intervention Radiology",
    fee: "FREE Consultation",
    rating: "4.7/5",
    experience: "13 Years Experience",
    location: "21 MG Road, Hyderabad",
    phone: "080-6541-7730",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Image-Guided Breast Procedures"
  },
];

const DoctorsSection = () => {
  const [showAll, setShowAll] = useState(false);
  const displayedDoctors = showAll ? doctorsData : doctorsData.slice(0, 6);

  return (
    <div style={{ padding: "80px 20px", backgroundColor: "#f8f9fa" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto", fontFamily: "'Poppins', sans-serif" }}>
        <div style={{ textAlign: "center", marginBottom: "50px" }}>
          <h2 style={{ fontSize: "42px", fontWeight: "800", color: "#0b1c39", marginBottom: "15px" }}>
            Our <span style={{ color: "#ffcb24" }}>Breast Lump Treatment Specialists</span>
          </h2>
          <p style={{ fontSize: "18px", color: "#555", maxWidth: "600px", margin: "0 auto", lineHeight: "1.8" }}>
            Expert comprehensive care for breast lump evaluation, diagnosis, and treatment with advanced technology and compassionate approach.
          </p>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "25px", justifyContent: "space-between" }}>
          {displayedDoctors.map((doc, index) => (
            <div
              key={index}
              style={{
                flex: "0 0 calc(33.33% - 17px)",
                backgroundColor: "#fff",
                borderRadius: "16px",
                padding: "25px",
                boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
                display: "flex",
                alignItems: "center",
                gap: "20px",
                border: "1px solid rgba(9,187,175,0.1)",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 12px 35px rgba(0,0,0,0.12)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 8px 30px rgba(0,0,0,0.08)";
              }}
            >
              <div style={{ position: "relative", flexShrink: 0 }}>
                <img
                  src={doc.image}
                  alt={doc.name}
                  style={{
                    width: "95px",
                    height: "95px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "3px solid #09bbaf",
                    backgroundColor: "#f8f8f8",
                  }}
                />
                {doc.online && (
                  <span
                    style={{
                      position: "absolute",
                      bottom: "8px",
                      right: "8px",
                      width: "14px",
                      height: "14px",
                      backgroundColor: "#09bbaf",
                      borderRadius: "50%",
                      border: "2px solid #fff",
                    }}
                    title="Online"
                  ></span>
                )}
              </div>

              <div style={{ flex: 1 }}>
                <h3 style={{ fontSize: "18px", fontWeight: "700", color: "#0b1c39", marginBottom: "6px" }}>
                  {doc.name}
                </h3>
                <p style={{ color: "#09bbaf", fontSize: "14px", marginBottom: "6px", fontWeight: "600" }}>
                  {doc.specialization}
                </p>
                <p style={{ color: "#555", fontSize: "14px", marginBottom: "6px" }}>
                  {doc.qualification}
                </p>
                <p style={{ fontWeight: "600", color: "#09bbaf", marginBottom: "6px", fontSize: "15px" }}>
                  {doc.fee}
                </p>
                <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "6px" }}>
                  <span style={{ fontSize: "14px", color: "#555" }}>⭐ {doc.rating}</span>
                  <span style={{ fontSize: "14px", color: "#555" }}>{doc.experience}</span>
                </div>
                <p style={{ fontSize: "13px", color: "#555", display: "flex", alignItems: "flex-start", gap: "6px", marginBottom: "6px", lineHeight: "1.4" }}>
                  📍 {doc.location}
                </p>
                <p style={{ fontSize: "13px", color: "#555", marginBottom: "15px" }}>
                  📞 {doc.phone}
                </p>

                <button
                  style={{
                    padding: "12px 20px",
                    border: "none",
                    borderRadius: "30px",
                    backgroundColor: "#ffcb24",
                    color: "#0b1c39",
                    cursor: "pointer",
                    width: "100%",
                    fontWeight: "600",
                    fontSize: "14px",
                    transition: "background-color 0.3s ease",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#ffd84f")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#ffcb24")}
                >
                  Book Free Consultation
                </button>
              </div>
            </div>
          ))}
        </div>

        {!showAll && doctorsData.length > 6 && (
          <div style={{ textAlign: "center", marginTop: "40px" }}>
            <button
              onClick={() => setShowAll(true)}
              style={{
                padding: "14px 40px",
                fontSize: "16px",
                borderRadius: "12px",
                border: "none",
                backgroundColor: "#09bbaf",
                color: "#fff",
                cursor: "pointer",
                fontWeight: "700",
                boxShadow: "0 8px 25px rgba(9,187,175,0.3)",
                transition: "background-color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#0dcfc2")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#09bbaf")}
            >
              View More Doctors ▼
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const BreastLumpTreatment = () => {
  const [activeTab, setActiveTab] = useState("overview");

  return (
    <>
      <Header />
      <Header2 />

      {/* Hero Section */}
      <section style={{
        background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
        padding: "160px 0 100px",
        marginTop: "56px",
        color: "white",
        textAlign: "center",
        position: "relative",
        overflow: "hidden"
      }}>
        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <h1 style={{
            fontSize: "3.5rem",
            fontWeight: "800",
            marginBottom: "20px",
            color: "white"
          }}>
            Advanced Breast Lump Treatment
          </h1>
          <p style={{
            fontSize: "1.3rem",
            marginBottom: "30px",
            opacity: "0.9",
            maxWidth: "700px",
            margin: "0 auto 30px",
            lineHeight: "1.6"
          }}>
            Comprehensive Breast Lump Evaluation with 99% Diagnostic Accuracy. Early Detection and Expert Management for Peace of Mind.
          </p>
          <div style={{ display: "flex", justifyContent: "center", gap: "20px", flexWrap: "wrap" }}>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book Free Consultation
            </button>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "2px solid #ffcb24",
              backgroundColor: "transparent",
              color: "#ffcb24",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.color = "#0b1c39";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "#ffcb24";
            }}>
              Emergency Breast Evaluation
            </button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section style={{ backgroundColor: "#fff", padding: "60px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>99%</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Diagnostic Accuracy</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>80%</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Benign Lumps</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>24-48</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Hours Report Time</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>15+</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Years Expert Team</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Doctors Section */}
      <DoctorsSection />

      {/* Navigation Tabs */}
      <section style={{ backgroundColor: "#fff", padding: "40px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div style={{ display: "flex", justifyContent: "center", gap: "10px", flexWrap: "wrap" }}>
            {[
              { id: "overview", label: "Overview", icon: "📋" },
              { id: "symptoms", label: "Symptoms", icon: "🔍" },
              { id: "types", label: "Types", icon: "🎯" },
              { id: "diagnosis", label: "Diagnosis", icon: "🔬" },
              { id: "treatment", label: "Treatment", icon: "⚕️" },
              { id: "prevention", label: "Prevention", icon: "🔄" },
              { id: "faq", label: "FAQ", icon: "🛡️" }
            ].map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{
                  padding: "12px 24px",
                  borderRadius: "25px",
                  border: "none",
                  backgroundColor: activeTab === tab.id ? "#09bbaf" : "#f8f9fa",
                  color: activeTab === tab.id ? "white" : "#555",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease"
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="container" style={{ padding: "80px 15px" }}>

        {/* Comprehensive Overview */}
        <section style={{ marginBottom: "80px" }}>
          <div style={{ textAlign: "center", marginBottom: "60px" }}>
            <h2 style={{ fontSize: "36px", fontWeight: "800", color: "#0b1c39", marginBottom: "20px" }}>
              Complete Guide to <span style={{ color: "#09bbaf" }}>Breast Lump Treatment</span>
            </h2>
          </div>

          {/* What are Breast Lumps */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "50px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "1px solid rgba(9,187,175,0.1)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px" }}>
                Understanding Breast Lumps
              </h3>
              
              <p style={{ color: "#555", lineHeight: "1.8", fontSize: "1.1rem", marginBottom: "25px" }}>
                Breast lumps are localized swellings, bumps, or masses that can be felt in breast tissue. 
                While discovering a breast lump can be alarming, it's important to know that approximately 
                80% of breast lumps are benign (non-cancerous). However, every breast lump requires proper 
                medical evaluation to rule out breast cancer and determine the appropriate treatment.
              </p>

              <div className="row">
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #09bbaf",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Common Characteristics</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Lumps may feel soft or hard, movable or fixed, painful or painless. They can vary in 
                      size from pea-sized to several centimeters and may change with menstrual cycles.
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #ffcb24",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>When to Seek Help</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Any new lump, persistent lump lasting through menstrual cycle, growing lump, 
                      or lump with skin changes requires immediate medical evaluation for proper diagnosis.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Symptoms & Characteristics */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Symptoms & Warning Signs
            </h3>

            <div className="row">
              {[
                {
                  title: "Palpable Mass", 
                  description: "New lump or thickening that feels different from surrounding breast tissue",
                  details: "May be painless or tender to touch"
                },
                {
                  title: "Skin Changes", 
                  description: "Dimpling, puckering, redness, or scaling of breast skin",
                  details: "Orange-peel appearance (peau d'orange)"
                },
                {
                  title: "Nipple Changes", 
                  description: "Inversion, retraction, or spontaneous discharge from nipple",
                  details: "Especially bloody or clear discharge"
                },
                {
                  title: "Size Changes", 
                  description: "Noticeable change in breast size or shape without explanation",
                  details: "One breast becoming larger than other"
                },
                {
                  title: "Pain", 
                  description: "Persistent pain in one spot that doesn't change with menstrual cycle",
                  details: "Not related to cyclical breast tenderness"
                },
                {
                  title: "Axillary Lump", 
                  description: "Swelling or lump in armpit area near breast tissue",
                  details: "Could indicate lymph node involvement"
                }
              ].map((symptom, index) => (
                <div key={index} className="col-lg-4 col-md-6 mb-4">
                  <div style={{
                    backgroundColor: "#fff",
                    borderRadius: "15px",
                    padding: "25px",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
                    border: "1px solid rgba(9,187,175,0.1)",
                    height: "100%",
                    transition: "transform 0.3s ease"
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                  onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                      {symptom.title}
                    </h5>
                    <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                      {symptom.description}
                    </p>
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "8px",
                      padding: "12px",
                      borderLeft: "3px solid #09bbaf"
                    }}>
                      <p style={{ color: "#666", fontSize: "0.9rem", lineHeight: "1.5", margin: 0 }}>
                        {symptom.details}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Breast Lump Types & Classification */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Types of Breast Lumps
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    type: "Fibroadenoma",
                    description: "Most common benign solid breast tumor in young women, smooth, rubbery, movable lumps",
                    treatment: "Monitoring or surgical removal if large or growing"
                  },
                  {
                    type: "Breast Cysts",
                    description: "Fluid-filled sacs common in women 35-50, often tender and fluctuate with menstrual cycle",
                    treatment: "Aspiration or monitoring if asymptomatic"
                  },
                  {
                    type: "Fibrocystic Changes",
                    description: "Benign condition with lumpy, tender breasts that change with menstrual cycle",
                    treatment: "Symptom management, rarely requires surgery"
                  },
                  {
                    type: "Intraductal Papilloma",
                    description: "Small wart-like growth in milk ducts near nipple, may cause bloody discharge",
                    treatment: "Surgical removal and pathological examination"
                  },
                  {
                    type: "Fat Necrosis",
                    description: "Hard, round lumps from injured fatty breast tissue, often after trauma or surgery",
                    treatment: "Monitoring, biopsy to confirm diagnosis"
                  },
                  {
                    type: "Breast Cancer",
                    description: "Malignant tumor that can present as hard, irregular, fixed mass with skin changes",
                    treatment: "Comprehensive cancer treatment plan"
                  }
                ].map((type, index) => (
                  <div key={index} className="col-lg-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      border: "2px solid #09bbaf",
                      height: "100%"
                    }}>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                        {type.type}
                      </h5>
                      <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                        {type.description}
                      </p>
                      <div style={{
                        backgroundColor: "#09bbaf",
                        color: "white",
                        padding: "8px 15px",
                        borderRadius: "20px",
                        display: "inline-block",
                        fontSize: "0.9rem",
                        fontWeight: "600"
                      }}>
                        {type.treatment}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Risk Factors */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#0b1c39",
              borderRadius: "20px",
              padding: "50px",
              color: "white"
            }}>
              <h3 style={{ fontSize: "28px", fontWeight: "800", marginBottom: "30px", color: "#ffcb24" }}>
                Risk Factors & Prevention
              </h3>
              
              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Non-Modifiable Risk Factors</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Female gender and increasing age</li>
                      <li style={{ marginBottom: "10px" }}>Family history of breast cancer</li>
                      <li style={{ marginBottom: "10px" }}>Genetic mutations (BRCA1, BRCA2)</li>
                      <li style={{ marginBottom: "10px" }}>Early menarche or late menopause</li>
                      <li>Personal history of breast conditions</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Modifiable Risk Factors</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Alcohol consumption</li>
                      <li style={{ marginBottom: "10px" }}>Obesity and sedentary lifestyle</li>
                      <li style={{ marginBottom: "10px" }}>Hormone replacement therapy</li>
                      <li style={{ marginBottom: "10px" }}>Not having children or late first pregnancy</li>
                      <li>Smoking and environmental factors</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Diagnostic Approaches */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Comprehensive Diagnostic Approaches
            </h3>

            <div className="row">
              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #09bbaf",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Imaging & Screening
                  </h4>
                  
                  <p style={{ color: "#555", lineHeight: "1.8", marginBottom: "25px" }}>
                    Advanced imaging techniques provide detailed visualization of breast tissue 
                    to characterize lumps and guide further management decisions.
                  </p>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Diagnostic Tools:</h6>
                    <div className="row">
                      <div className="col-6">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}>Digital Mammography</li>
                          <li style={{ marginBottom: "8px" }}>Breast Ultrasound</li>
                          <li style={{ marginBottom: "8px" }}>Breast MRI</li>
                        </ul>
                      </div>
                      <div className="col-6">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}>3D Tomosynthesis</li>
                          <li style={{ marginBottom: "8px" }}>Ductography</li>
                          <li style={{ marginBottom: "8px" }}>Thermography</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Screening Guidelines:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "8px" }}>Annual mammography starting at age 40</li>
                      <li style={{ marginBottom: "8px" }}>Earlier screening for high-risk patients</li>
                      <li style={{ marginBottom: "8px" }}>Monthly breast self-exams</li>
                      <li>Clinical breast exams annually</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #ffcb24",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Biopsy & Pathology
                  </h4>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Biopsy Techniques:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>Fine Needle Aspiration (FNA) - for fluid-filled cysts</li>
                      <li style={{ marginBottom: "10px" }}>Core Needle Biopsy - gold standard for tissue diagnosis</li>
                      <li style={{ marginBottom: "10px" }}>Vacuum-Assisted Biopsy - for larger tissue samples</li>
                      <li style={{ marginBottom: "10px" }}>Surgical Excisional Biopsy - complete lump removal</li>
                      <li>Image-guided biopsies for non-palpable lumps</li>
                    </ul>
                  </div>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Pathological Analysis:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>Histopathological examination</li>
                      <li style={{ marginBottom: "10px" }}>Hormone receptor testing</li>
                      <li style={{ marginBottom: "10px" }}>HER2/neu status evaluation</li>
                      <li style={{ marginBottom: "10px" }}>Ki-67 proliferation index</li>
                      <li>Genetic profiling when indicated</li>
                    </ul>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Rapid Diagnosis:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>24-48 hour biopsy report turnaround</li>
                      <li style={{ marginBottom: "10px" }}>Multidisciplinary tumor board review</li>
                      <li>Comprehensive treatment planning</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Treatment Timeline */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Diagnosis & Treatment Timeline
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    period: "Day 1",
                    title: "Initial Evaluation",
                    activities: ["Clinical breast examination", "Detailed medical history", "Risk assessment", "Imaging planning"]
                  },
                  {
                    period: "Day 2-3",
                    title: "Diagnostic Imaging",
                    activities: ["Mammogram and ultrasound", "MRI if indicated", "Image characterization", "BI-RADS scoring"]
                  },
                  {
                    period: "Day 4-5",
                    title: "Biopsy Procedure",
                    activities: ["Image-guided biopsy", "Tissue sampling", "Pathology processing", "Initial assessment"]
                  },
                  {
                    period: "Day 6-7",
                    title: "Results & Planning",
                    activities: ["Final pathology report", "Multidisciplinary review", "Treatment discussion", "Next steps planning"]
                  }
                ].map((stage, index) => (
                  <div key={index} className="col-lg-3 col-md-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      textAlign: "center",
                      border: "1px solid rgba(9,187,175,0.2)",
                      height: "100%"
                    }}>
                      <div style={{ 
                        backgroundColor: "#09bbaf", 
                        color: "white", 
                        width: "60px", 
                        height: "60px", 
                        borderRadius: "50%", 
                        display: "flex", 
                        alignItems: "center", 
                        justifyContent: "center", 
                        margin: "0 auto 15px",
                        fontWeight: "700",
                        fontSize: "0.9rem"
                      }}>
                        {stage.period}
                      </div>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.1rem" }}>
                        {stage.title}
                      </h5>
                      <ul style={{ color: "#555", fontSize: "0.85rem", paddingLeft: "15px", textAlign: "left" }}>
                        {stage.activities.map((activity, idx) => (
                          <li key={idx} style={{ marginBottom: "8px" }}>{activity}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Treatment Options */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "2px solid rgba(255,203,36,0.3)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px", textAlign: "center" }}>
                Comprehensive Treatment Options
              </h3>

              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Benign Lump Treatments</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Observation and monitoring for stable fibroadenomas</li>
                      <li style={{ marginBottom: "10px" }}>Fine needle aspiration for symptomatic cysts</li>
                      <li style={{ marginBottom: "10px" }}>Surgical excision for growing or large benign lumps</li>
                      <li>Hormonal management for fibrocystic changes</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Cancer Treatments</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Lumpectomy with radiation therapy</li>
                      <li style={{ marginBottom: "10px" }}>Mastectomy with reconstruction options</li>
                      <li style={{ marginBottom: "10px" }}>Chemotherapy and targeted therapy</li>
                      <li>Hormone therapy for hormone receptor-positive cancers</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* FAQ Section */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Frequently Asked Questions
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              {[
                {
                  question: "Are all breast lumps cancerous?",
                  answer: "No, the vast majority of breast lumps are not cancerous. Approximately 80% of breast lumps that are biopsied turn out to be benign (non-cancerous). Common benign breast conditions include fibroadenomas, cysts, fibrocystic changes, and intraductal papillomas. However, it's crucial to understand that any new breast lump requires proper medical evaluation because while most are benign, some can be cancerous. The only way to definitively determine whether a breast lump is cancerous is through proper diagnostic testing, which may include imaging studies like mammogram or ultrasound, and often a biopsy. Never assume a breast lump is harmless without professional medical assessment, as early detection of breast cancer significantly improves treatment outcomes and survival rates."
                },
                {
                  question: "What tests are done to evaluate a breast lump?",
                  answer: "The evaluation of a breast lump typically follows a stepwise approach: Clinical Breast Examination - A healthcare provider physically examines the breasts and armpits; Imaging Studies - Mammogram (X-ray of breast tissue), Breast Ultrasound (uses sound waves to characterize lumps), sometimes Breast MRI (for high-risk patients or complex cases); Biopsy - The definitive diagnostic test where tissue samples are taken from the lump for pathological examination. Additional tests may include: Fine Needle Aspiration - for fluid-filled cysts, Core Needle Biopsy - obtains small tissue cores, Vacuum-Assisted Biopsy - removes more tissue, Surgical Biopsy - removes entire lump. The specific tests recommended depend on factors like your age, the lump's characteristics, family history, and initial examination findings. This comprehensive approach ensures accurate diagnosis and appropriate treatment planning."
                },
                {
                  question: "When should I worry about a breast lump?",
                  answer: "You should seek immediate medical evaluation for a breast lump if you notice any of these warning signs: A new lump that doesn't go away after your next menstrual period; A lump that feels hard, irregular in shape, or firmly fixed in place; A persistent lump that grows larger over time; Skin changes over the lump like dimpling, puckering, or redness; Nipple changes including inversion, retraction, or spontaneous discharge (especially if bloody); Swelling in armpit or around collarbone; Persistent breast pain in one specific area. However, it's important to remember that most breast lumps are benign, and early evaluation provides peace of mind. Don't wait to see if a lump goes away on its own - timely medical assessment is crucial for both benign conditions that may need treatment and for early cancer detection when treatment is most effective."
                },
                {
                  question: "Can breast lumps go away on their own?",
                  answer: "Some types of breast lumps can resolve spontaneously, while others persist and require medical intervention. Cysts (fluid-filled sacs) may come and go, often changing with menstrual cycles, and sometimes resolve on their own. Lumps related to fibrocystic changes may fluctuate in size and tenderness throughout the menstrual cycle. However, solid lumps like fibroadenomas typically do not disappear without treatment and may persist or grow over time. Cancerous lumps generally do not resolve on their own and typically continue to grow if left untreated. The critical point is that you should never assume a breast lump will go away on its own. Any persistent lump lasting through a complete menstrual cycle, any new lump in postmenopausal women, or any lump that causes concern should be professionally evaluated. Self-monitoring without medical assessment can delay diagnosis of serious conditions."
                },
                {
                  question: "What's the difference between a cyst and a solid breast lump?",
                  answer: "Cysts and solid breast lumps have distinct characteristics: Breast Cysts are fluid-filled sacs that feel soft, smooth, and movable, often described as feeling like grapes. They may be tender, especially before menstruation, and can change size quickly. Ultrasound can confirm they contain fluid, and they can often be drained (aspirated) with a needle. Solid Breast Lumps feel firmer and maintain their shape when palpated. They include conditions like fibroadenomas (smooth, rubbery, movable) or cancerous tumors (often hard, irregular, fixed). Diagnostic imaging can suggest whether a lump is solid or cystic, but biopsy is often needed for definitive diagnosis of solid lumps. The key differences are: Composition - cysts contain fluid, solid lumps contain tissue; Feel - cysts are usually softer and more movable; Ultrasound appearance - cysts appear as dark, fluid-filled spaces, solid lumps show tissue architecture; Management - cysts may be drained, solid lumps often require biopsy. Proper diagnosis is essential as management differs significantly between these two types of breast lumps."
                }
              ].map((faq, index) => (
                <div key={index} style={{ 
                  marginBottom: "25px",
                  paddingBottom: "25px",
                  borderBottom: index < 4 ? "1px solid #eee" : "none"
                }}>
                  <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "10px" }}>
                    {faq.question}
                  </h5>
                  <p style={{ color: "#555", lineHeight: "1.6", margin: 0 }}>
                    {faq.answer}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Final CTA */}
          <div style={{
            background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
            borderRadius: "20px",
            padding: "60px 40px",
            textAlign: "center",
            color: "white"
          }}>
            <h2 style={{ fontSize: "2.5rem", fontWeight: "800", marginBottom: "20px" }}>
              Concerned About a Breast Lump?
            </h2>
            <p style={{ fontSize: "1.2rem", marginBottom: "30px", opacity: "0.9", maxWidth: "600px", margin: "0 auto 30px" }}>
              Our expert team provides comprehensive breast lump evaluation with rapid diagnosis and compassionate care.
            </p>
            <button style={{
              padding: "18px 45px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "800",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book FREE Consultation Now
            </button>
            <p style={{ marginTop: "20px", fontSize: "1rem", opacity: "0.8" }}>
              Breast Surgery: <strong>080-6541-7705</strong> | Radiology: <strong>080-6541-7715</strong>
            </p>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default BreastLumpTreatment;